import queryString from "query-string";
import { BaseRepository } from "../Base/base.repository";
import { GetHomeDto } from "./dto/get.dto";
import { ServerlessConfigure } from "../../config/serverless-configure";
import { GetListParams, HomeRepositoryInterface } from "./home.repository.d";
import { CreateHomeDto } from "./dto/create.dto";
import { UpdateHomeDto } from "./dto/update.dto";
import { RequestHomeDto } from "./dto/request.dto";

export class HomeRepository
  extends BaseRepository<GetHomeDto>
  implements HomeRepositoryInterface
{
  constructor() {
    super(
      {
        baseURL: ServerlessConfigure.ApiEndpoint,
      },
      {
        hasSendToken: true,
      },
    );
  }

  async getList(params: GetListParams) {
    const response = await this.apiRequest.getList({
      url: `/homes?${queryString.stringify(params)}`,
    });

    return response.data.Items;
  }

  async create({
    homeName,
    homeBuilderId,
    homeBuilderName,
    homeRange,
    homeLotSize,
    homeBedNo,
    homeBathNo,
    homeGarageNo,
    homeFromPrice,
    homeToPrice,
    homeLevelPath,
    homeStorey,
    homeFloorplanMapBase64,
  }: CreateHomeDto) {
    const response = await this.apiRequest.post<GetHomeDto>({
      url: "/homes",
      data: {
        homeName,
        homeBuilderId,
        homeBuilderName,
        homeRange,
        homeLotSize: homeLotSize || 0,
        homeBedNo: homeBedNo || 0,
        homeBathNo: homeBathNo || 0,
        homeGarageNo: homeGarageNo || 0,
        homeFromPrice: homeFromPrice || 0,
        homeToPrice: homeToPrice || 0,
        homeLevelPath,
        homeStorey,
        homeFloorplanMapBase64,
      },
    });

    return response;
  }

  async update({
    id,
    homeName,
    homeRange,
    homeLotSize,
    homeBedNo,
    homeBathNo,
    homeGarageNo,
    homeFromPrice,
    homeToPrice,
    homeLevelPath,
    homeStorey,
    isActive,
    status,
    homeFloorplanMapBase64,
    homeBuilderId,
  }: UpdateHomeDto) {
    const response = await this.apiRequest.put<GetHomeDto>({
      url: `/homes/${id}`,
      data: {
        homeName,
        homeRange,
        homeLotSize: homeLotSize || undefined,
        homeBedNo: homeBedNo || undefined,
        homeBathNo: homeBathNo || undefined,
        homeGarageNo: homeGarageNo || undefined,
        homeFromPrice: homeFromPrice || undefined,
        homeToPrice: homeToPrice || undefined,
        homeLevelPath: homeLevelPath,
        homeStorey: homeStorey,
        isActive,
        status,
        homeFloorplanMapBase64,
        homeBuilderId,
      },
    });

    return response;
  }

  async request({
    homeName,
    homeRange,
    homeLotSize,
    homeBedNo,
    homeBathNo,
    homeGarageNo,
    homeFromPrice,
    homeToPrice,
    homeStorey,
  }: RequestHomeDto) {
    const response = await this.apiRequest.post<GetHomeDto>({
      url: "/homes",
      data: {
        homeName,
        homeRange,
        homeLotSize: homeLotSize || 0,
        homeBedNo: homeBedNo || 0,
        homeBathNo: homeBathNo || 0,
        homeGarageNo: homeGarageNo || 0,
        homeFromPrice: homeFromPrice || 0,
        homeToPrice: homeToPrice || 0,
        homeStorey,
      },
    });

    return response;
  }

  delete(id: string) {
    return this.apiRequest.delete({
      url: `/homes/${id}`,
    });
  }
}
